import { useQuery } from "@tanstack/react-query";

import TokenHelper from "@/utils/tokenHelper";
import { QUERY_KEYS } from "@api/queryKeys";

import {
  adaptPatentPrimaryCategory,
  adaptPatentPrimaryCategoryFilter,
} from "./adaptPatentPrimaryCategory.data";
import { patentPrimaryCategoryApi } from "./patentPrimaryCategory.service";

export const usePatentPrimaryCategoryQuery = () => {
  const isAuthenticated = !!TokenHelper.getAccessToken();

  return useQuery({
    queryKey: [QUERY_KEYS.patentPrimaryCategory],
    queryFn: () => patentPrimaryCategoryApi.getPrimaryCategoryFilterData(),
    throwOnError: false,
    select: (data) => adaptPatentPrimaryCategory(data),
    refetchOnMount: true,
    staleTime: 5 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    enabled: isAuthenticated,
  });
};

export const usePatentPrimaryCategoryFilterQuery = () => {
  const isAuthenticated = !!TokenHelper.getAccessToken();

  return useQuery({
    queryKey: [QUERY_KEYS.patentPrimaryCategory],
    queryFn: () => patentPrimaryCategoryApi.getPrimaryCategoryFilterData(),
    throwOnError: false,
    select: (data) => adaptPatentPrimaryCategoryFilter(data),
    refetchOnMount: true,
    staleTime: 5 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    enabled: isAuthenticated,
  });
};
